import React, { Fragment } from 'react';
import Button from '4all-ui/components/Button';
import { PRODUCT_ADDONS } from '../../../../helpers/constants';
import * as styles from './style';
import withCreateProductAddons from '../../../../containers/CreateProductsAddons';

const renderAddButtons = (steps, step, selectCurrentStepSelection) => {
  const canAddProductStep = canAddProducts(steps, step);
  const canAddVariationStep = canAddVariations(steps, step);

  if (step.onlyProducts || step.addonType === PRODUCT_ADDONS.SELECTED_PRODUCTS) {
    return (
      <Button
        width="100%"
        onClick={() => selectCurrentStepSelection(step, PRODUCT_ADDONS.SELECTED_PRODUCTS)}
        className="btn-add-products"
      >
        Adicionar Produtos
      </Button>
    );
  } else if (!step.addonType && (canAddProductStep && canAddVariationStep)) {
    return (
      <Fragment>
        <Button
          width="49%"
          onClick={() => selectCurrentStepSelection(step, PRODUCT_ADDONS.SELECTED_PRODUCTS)}
          className="btn-add-products"
        >
          Add Produtos
        </Button>
        <Button
          width={'49%'}
          onClick={() =>
            selectCurrentStepSelection(step, PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS)
          }
          className="btn-add-variations"
        >
          Add Variações
        </Button>
      </Fragment>
    );
  } else if (!step.addonType && !canAddProductStep && canAddVariationStep) {
    return (
      <Button
        width="100%"
        onClick={() => selectCurrentStepSelection(step, PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS)}
        className="btn-add-variations"
      >
        Adicionar Variações
      </Button>
    );
  } else if (!step.addonType && canAddProductStep && !canAddVariationStep) {
    return (
      <Button
        width="100%"
        onClick={() => selectCurrentStepSelection(step, PRODUCT_ADDONS.SELECTED_PRODUCTS)}
        className="btn-add-products"
      >
        Adicionar Produtos
      </Button>
    );
  }
  return null;
};

const canAddProducts = (steps, step) => {
  const stepsCopy = [...steps];
  const stepIndex = stepsCopy.find(s => s.id === step.id)
    ? stepsCopy.find(s => s.id === step.id).id
    : 0;
  const firstVariationStep = stepsCopy
    .reverse()
    .find(s => s.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS)
    ? stepsCopy.reverse().find(s => s.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS).id
    : -1;

  return stepIndex <= firstVariationStep || firstVariationStep === -1;
};

const canAddVariations = (steps, step) => {
  const lastProductStep = [...steps]
    .reverse()
    .find(st => st.addonType === PRODUCT_ADDONS.SELECTED_PRODUCTS);
  const lastProductStepIndex = lastProductStep ? lastProductStep.id : -1;

  return (step.id > lastProductStepIndex || lastProductStepIndex === -1) && steps[0].id !== step.id;
};

const AddStepDataButtons = ({ productAddons, step, selectCurrentStepSelection }) => {
  return (
    <styles.ButtonsContainer>
      {renderAddButtons(productAddons.steps, step, selectCurrentStepSelection)}
    </styles.ButtonsContainer>
  );
};

export default withCreateProductAddons(AddStepDataButtons);



// WEBPACK FOOTER //
// ./src/components/ProductAddons/CustomSteps/AddStepDataButtons/index.js